import wordCount from "utils/wordCount";

const MINIMUM_WORD_COUNT_FOR_SUGGESTED_DESCRIPTION = 25 as const;

export function descriptionIsConsideredSufficient(
  description: string
): boolean {
  return wordCount(description) >= MINIMUM_WORD_COUNT_FOR_SUGGESTED_DESCRIPTION;
}
